"use strict";

var _classCallCheck = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalInteractorBase = void 0;

var Enums_1 = require("../Enums");

var ExternalInteractorBase = function ExternalInteractorBase(container) {
  _classCallCheck(this, ExternalInteractorBase);

  this.container = container;
  this.type = Enums_1.InteractorType.External;
};

exports.ExternalInteractorBase = ExternalInteractorBase;